import axios from 'axios';
import { getApiHeaders } from '../../utils/apiHelpers';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/gestione/haccp`;

export const haccpApi = {
  get: (path, opts = {}) => axios.get(`${BASE}${path}`, { headers: getApiHeaders(), ...opts }).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: getApiHeaders(), timeout: 180000 }).then((r) => r.data),
  put: (path, body) => axios.put(`${BASE}${path}`, body, { headers: getApiHeaders() }).then((r) => r.data),
  del: (path) => axios.delete(`${BASE}${path}`, { headers: getApiHeaders() }).then((r) => r.data),
};

export const erroreHaccp = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  return Array.isArray(d) ? 'Controlla i dati inseriti' : fallback;
};

export const dataIt = (s) => {
  if (!s) return '-';
  if (/^\d{2}\/\d{2}\/\d{4}/.test(s)) return s.slice(0, 10);
  return s.slice(0, 10).split('-').reverse().join('/');
};

export const oggiIso = () => new Date().toLocaleDateString('sv-SE');
export const giorniFa = (n) => new Date(Date.now() - n * 86400000).toLocaleDateString('sv-SE');

export const scaricaPdf = async (path, nome) => {
  const blob = await haccpApi.get(path, { responseType: 'blob', timeout: 180000 });
  const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const a = Object.assign(document.createElement('a'), { href: url, download: nome });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
